import React from 'react'

const WarningSVG = () => (
	<svg width="215" height="318" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g opacity=".12">
			<rect width="318" height="318" rx="159" fill="#FEE4E2" />
			<path
				d="M152.313 40.453a11 11 0 0 1 13.374 0l22.408 17.156a11 11 0 0 0 6.963 2.262l28.212-.708a10.999 10.999 0 0 1 10.82 7.86l8.044 27.051a11 11 0 0 0 4.304 5.923l23.241 16.01a11 11 0 0 1 4.132 12.719l-9.392 26.613a10.999 10.999 0 0 0 0 7.321l9.392 26.613a11 11 0 0 1-4.132 12.719l-23.241 16.01a10.998 10.998 0 0 0-4.304 5.923l-8.044 27.051a11 11 0 0 1-10.82 7.861l-28.212-.709a10.997 10.997 0 0 0-6.963 2.263l-22.408 17.156a11 11 0 0 1-13.374 0l-22.408-17.156a10.993 10.993 0 0 0-6.963-2.263l-28.212.709a11.002 11.002 0 0 1-10.82-7.861l-8.044-27.051a10.998 10.998 0 0 0-4.304-5.923l-23.24-16.01a10.999 10.999 0 0 1-4.133-12.719l9.392-26.613a10.999 10.999 0 0 0 0-7.321l-9.392-26.613a11 11 0 0 1 4.133-12.719l23.24-16.01a11 11 0 0 0 4.304-5.923l8.044-27.05a11 11 0 0 1 10.82-7.861l28.212.708a10.996 10.996 0 0 0 6.963-2.262l22.408-17.156Z"
				fill="#F97A70"
			/>
			<mask
				id="a"
				maskUnits="userSpaceOnUse"
				x="79"
				y="88"
				width="159"
				height="159"
			>
				<path fill="#D9D9D9" d="M79 88h159v159H79z" />
			</mask>
			<g mask="url(#a)">
				<path
					d="M153.531 181.005v-56.313h9.938v56.313h-9.938Zm0 29.302v-9.937h9.938v9.937h-9.938Z"
					fill="#fff"
				/>
			</g>
		</g>
	</svg>
)

export default WarningSVG
